module.exports = __webpack_public_path__ + "static/media/om_beard_medium_round__oval_shadow.381ee080.png";